import {
  baseApi,
  ChatHistoryListResponse,
  ChatRequest,
  ChatResponse,
  ChatTitle,
} from "@racoon/api";

const chatApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getChats: build.query<ChatTitle[], void>({
      query: () => "/v1/platform/chat/chats",
      providesTags: ["Chats"],
    }),
    chatHistory: build.query<ChatHistoryListResponse, string>({
      query: (chat_id) => ({
        url: `/v1/platform/chat/chat-history`,
        params: { chat_id },
      }),
    }),
    chatWithAgent: build.mutation<ChatResponse, ChatRequest>({
      query: (body) => ({
        url: "/v1/platform/chat/chat_with_agent",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Chats"],
    }),
  }),
});

export const { useGetChatsQuery, useChatHistoryQuery, useChatWithAgentMutation } = chatApi;
